import { useEffect, useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { api, fmtMoney, fmtDate } from '../lib/api.js';

export default function Receipts() {
  const { isOwner } = useOutletContext();
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/api/receipts').then(({ receipts }) => setList(receipts)).catch(e => setErr(e.message));
  }, []);

  if (err) return <div className="text-rust-700 text-sm">{err}</div>;
  if (!list) return <div className="text-ink-700/60 italic">Loading…</div>;

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-serif text-olive-900">Receipts</h1>
        <Link to="/receipts/new" className="btn-primary">+ Log Receipt</Link>
      </header>

      <p className="text-xs text-ink-700/60">
        {isOwner ? 'All receipts.' : 'Your submitted receipts.'} OCR + voice line-allocation coming with the LLM provider plug-in.
      </p>

      {list.length === 0 ? (
        <div className="card text-center py-10">
          <p className="text-ink-700/70">No receipts yet.</p>
          <Link to="/receipts/new" className="btn-primary mt-4">Log first receipt</Link>
        </div>
      ) : (
        <ul className="space-y-2">
          {list.map(r => (
            <li key={r.id} className="card">
              <div className="flex items-start gap-3">
                <div className="flex-1">
                  <div className="font-medium text-ink-900">{r.vendor}</div>
                  <div className="text-sm text-ink-700/70">
                    {fmtDate(r.date)}
                    {!!r.no_receipt && <span className="ml-2 pill bg-gold-500/15 text-gold-600">no receipt</span>}
                    {!!r.paid_by_user_id && (
                      <span className="ml-2 pill bg-rust-500/10 text-rust-700">
                        personal card · {r.reimbursed_at ? 'reimbursed' : 'reimbursable'}
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-ink-700/60 mt-1">
                    {!!r.submitted_by_name && <span>by {r.submitted_by_name}</span>}
                    {!!r.payment_method && <span> · {r.payment_method}</span>}
                  </div>
                </div>
                <div className="text-lg font-semibold text-olive-900">{fmtMoney(r.total_cents)}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
